<template>
    <veui-form class="add-award-wrapper" :data="value" ref="form" @submit="addAward">
        <veui-field label="奖项名称：" name="name" field="name" rules="required" :readonly="readonly">
            <veui-input v-model="name" placeholder="数字、字母、汉字" autocomplete="off"/>
        </veui-field>
        <veui-field label="奖项描述：" name="description" field="description" :readonly="readonly">
            <veui-textarea v-model="description"/>
        </veui-field>
        <veui-field label="短信模板：" name="smsTemplate" field="smsTemplate" rules="required" :readonly="readonly">
            <veui-textarea v-model="smsTemplate"/>
        </veui-field>
        <veui-field label="每日最多领券数量：" name="availablePerDay" field="availablePerDay" :readonly="readonly">
            <veui-input v-model="availablePerDay"/>
        </veui-field>
    </veui-form>
</template>

<script>
import {Form, Field, Input, Textarea} from 'veui';
import {get} from 'lodash';

export default {
    name: 'AddAward',
    components: {
        'veui-form': Form,
        'veui-field': Field,
        'veui-input': Input,
        'veui-textarea': Textarea
    },
    props: {
        value: Object,
        readonly: Boolean
    },
    model: {
        event: 'change'
    },
    computed: ['name', 'description', 'smsTemplate', 'availablePerDay'].reduce((result, key) => {
        result[key] = {
            get() {
                return get(this.value, key);
            },
            set(val) {
                this.$emit('change', {
                    ...this.value,
                    [key]: val
                });
            }
        };
        return result;
    }, {}),
    methods: {
        submit() {
            return this.$refs.form.submit();
        },
        validate() {
            return this.$refs.form.validate();
        },
        addAward(data) {
            this.$emit('addaward', data);
        },
        getEmptyAward() {
            return {
                index: '',
                name: '',
                description: '',
                smsTemplate: '',
                availablePerDay: ''
            };
        }
    }
};
</script>

<style lang="less">
.add-award-wrapper {
    .veui-field {
        .veui-form-label {
            width: 142px;
        }
        .veui-input-input {
            width: 300px;
        }
    }
}
</style>

